firebird.factory('videoConnectivityService', [
    '$timeout',
    'logService',
    'phoneConferenceService',
    'analyticsWrapperService',
    'videoGlobalService',
    function ($timeout, logService, phoneConferenceService, analyticsWrapperService, videoGlobalService) {
        var service = {
            initialize: initialize
        };

        var self;

        const logger = new LogServiceWrapper(logService, '[videoroomCtrl] videoConnectivityService');

        return service;

        function initialize(selfParam) {
            self = selfParam;

            // state for connectivity check with external service.
            // this data and code should be moved to connectivityService or elsewhere. It should also include some form of UDP test.
            self.checkConn = {
                timeout: 10000,
                timer: null,
                xhr1: null,
                status1: null,
                start1: 0,
                end1: 0,
                xhr2: null,
                status2: null,
                start2: 0,
                end2: 0,
                callbacks: [] // pending callbacks in checkConnectivity
            };

            self.checkConnectivity = checkConnectivity;
            self.stopCheckConnectivity = stopCheckConnectivity;
            self.logCheckConnectivityResult = logCheckConnectivityResult;
        }

        // check if we are disconnected from Internet by checking Ajax to our media server as well as external third-party web server.
        // if timeout is supplied in milliseconds, that is used. otherwise defaults to 10s.
        // callback if supplied is invoked with connectivity status (true or false).
        function checkConnectivity(reason, timeout, callback) {
            // allow reentrant call, store callbacks, and invoke them when done.
            if (callback) {
                self.checkConn.callbacks.push(callback);
            }
            var invokeCallback = function (value) {
                var callbacks = self.checkConn.callbacks.splice(0, self.checkConn.callbacks.length);
                callbacks.forEach(function (callback) {
                    callback(value);
                });
            };

            if (!self.checkConn.timer && !self.checkConn.xhr1 && !self.checkConn.xhr2) {
                logger.log('checkConnectivity', 'check connectivity scheduled because of', reason);

                // timer used to avoid interrupting or delaying the caller callback function
                self.checkConn.timer = $timeout(function () {
                    var serverHost = phoneConferenceService.getPhoneData().server;

                    self.checkConn.start1 = self.checkConn.start2 = Date.now();
                    self.checkConn.end1 = self.checkConn.end2 = 0;
                    self.checkConn.status1 = self.checkConn.status2 = null;

                    self.checkConn.timer = $timeout(function () {
                        self.checkConn.timer = null;
                        self.logCheckConnectivityResult(serverHost, 'timeout', reason);
                        self.stopCheckConnectivity(true); // abort pending
                        invokeCallback(false);
                    }, timeout || self.checkConn.timeout); // limit to 10 seconds for connectivity check

                    var handler = function () {
                        if (self.checkConn.status1 && self.checkConn.status2) {
                            if (self.checkConn.timer) {
                                $timeout.cancel(self.checkConn.timer);
                                self.checkConn.timer = null;
                            }
                            self.logCheckConnectivityResult(serverHost, undefined, reason);
                            invokeCallback(true);
                        }
                    };

                    var xhr1 = (self.checkConn.xhr1 = new XMLHttpRequest());
                    xhr1.onload = xhr1.onerror = function (event) {
                        if (self.checkConn.xhr1) {
                            self.checkConn.status1 = event.type;
                            self.checkConn.end1 = Date.now();
                            self.checkConn.xhr1 = null;
                            handler();
                        }
                    };
                    var uploadUrl = 'https://' + serverHost + '/speedtest.bin?n=' + ('' + Math.random()).substr(2, 20);
                    xhr1.open('POST', uploadUrl);
                    xhr1.withCredentials = true;
                    xhr1.send('check');

                    var xhr2 = (self.checkConn.xhr2 = new XMLHttpRequest());
                    xhr2.onload = xhr2.onerror = function (event) {
                        if (self.checkConn.xhr2) {
                            self.checkConn.status2 = event.type;
                            self.checkConn.end2 = Date.now();
                            self.checkConn.xhr2 = null;
                            handler();
                        }
                    };
                    // this will always fail, but from server.
                    var extUrl = 'https://www.google.com/?r=' + ('' + Math.random()).substr(2, 10);
                    xhr2.open('GET', extUrl);
                    xhr2.send();
                }, 0);
            } else {
                logService.log('videoroomCtrl checkConnectivity not scheduled');
            }
        }

        function stopCheckConnectivity(keepCallbacks) {
            if (self.checkConn.timer) {
                $timeout.cancel(self.checkConn.timer);
                self.checkConn.timer = null;
            }
            if (self.checkConn.xhr1) {
                var xhr1 = self.checkConn.xhr1;
                self.checkConn.xhr1 = null;
                xhr1.abort();
            }
            if (self.checkConn.xhr2) {
                var xhr2 = self.checkConn.xhr2;
                self.checkConn.xhr2 = null;
                xhr2.abort();
            }
            if (!keepCallbacks && self.checkConn.callbacks.length > 0) {
                self.checkConn.callbacks.splice(0, self.checkConn.callbacks.length);
            }
        }

        function logCheckConnectivityResult(server, type, reason) {
            var time1 = (self.checkConn.end1 || undefined) - self.checkConn.start1;
            var time2 = (self.checkConn.end2 || undefined) - self.checkConn.start2;

            logger.log(
                'logCheckConnectivityResult',
                `checkConnectivity ${type || 'completed'} result=${self.checkConn.status1}/${
                    self.checkConn.status2
                } time=${time1}/${time2} reason=${reason}`
            );

            var value1 = {
                status1: self.checkConn.status1 || '0',
                status2: self.checkConn.status2 || '0',
                time1: isNaN(time1) ? 'NaN' : time1,
                time2: isNaN(time2) ? 'NaN' : time2,
                reason: reason
            };
            self.msgflowEvent('connectivity ' + (type || 'check'), value1);

            if (
                reason !== 'networkCollectMoreStatsAfter' ||
                type === 'timeout' ||
                Math.max(time1, time2) > self.networkState.moreStats.connectivityDelayThreshold
            ) {
                // need copy of value1 since analytics modifies its attributes.
                var value2 = Object.assign({ sfuEvent: true, server: (server || '').split('.')[0] }, value1);
                analyticsWrapperService.eventTrack(
                    'Meeting - connectivity ' +
                        (type || 'check') +
                        ' - ' +
                        (isNaN(time2) ? 'failed internet' : isNaN(time1) ? 'failed server' : 'success'),
                    value2
                );
            }
        }
    }
]);
